import {
  parseArtDesignsRequest,
  parseArtPreferences,
  parseCampaignArt,
} from 'services/campaignArtServices';

import { axiosWithToken } from './axios';

export const fetchGetCampaignArt = async ({ artId, campaignId }) => {
  const params = { campaign_id: campaignId };

  if (artId) params.id = artId;

  const response = await axiosWithToken.get('art', { params });
  const { art_designs: artDesigns } = JSON.parse(response.data.body);

  const designArts = artDesigns
    .filter((el) => el.type === 'proof')
    .map((campaignArt) => parseCampaignArt(campaignArt));

  const artPreferences =
    artDesigns
      .filter((el) => el.type === 'client')
      .map((campaignArt) => parseArtPreferences(campaignArt))[0] || {};

  return { designArts, artPreferences };
};

export const fetchAddCampaignConcept = async ({
  campaignId,
  uploads,
  text,
  colors,
  concept,
  phone,
  email,
  brand,
  website,
  facebook,
  instagram,
  twitter,
  tiktok,
  snapchat,
}) => {
  await axiosWithToken.post('art', {
    campaign_id: campaignId,
    uploads,
    text,
    colors,
    concept,
    phone,
    email,
    brand_name: brand,
    website,
    facebook,
    instagram,
    twitter,
    tiktok,
    snapchat,
  });
};

export const fetchApproveCampaignArt = async ({ id, campaignId }) => {
  await axiosWithToken.post('art', {
    id,
    campaign_id: campaignId,
    action: 'approve',
  });
};

export const fetchRejectCampaignArt = async ({ id, campaignId, note }) => {
  await axiosWithToken.post('art', {
    id,
    campaign_id: campaignId,
    action: 'reject',
    note,
  });
};

export const fetchAddComment = async ({ campaignId, userId, artId, note }) => {
  await axiosWithToken.post('art', {
    campaign_id: campaignId,
    user_id: userId,
    note,
    id: artId,
    action: 'message',
  });
};

export const fetchEditCampaignConcept = async ({
  artId,
  campaignId,
  uploads,
  text,
  colors,
  concept,
  phone,
  email,
  brand,
  website,
  facebook,
  instagram,
  twitter,
  tiktok,
  snapchat,
}) => {
  await axiosWithToken.post('art', {
    action: 'art.update',
    id: artId,
    campaign_id: campaignId,
    uploads,
    text,
    colors,
    concept,
    phone,
    email,
    brand_name: brand,
    website,
    facebook,
    instagram,
    twitter,
    tiktok,
    snapchat,
  });
};

export const fetchRequestCampaignArtChange = async (data) => {
  const response = await axiosWithToken.post(
    'campaign/art_change/request',
    data
  );

  const request = JSON.parse(response.data.body);

  return {
    id: request.id,
    description: request.description,
    attachments: request.attachments,
    history: request.comments,
    status: request.status,
    priceQuote: request.price_quote,
  };
};

export const fetchActionCampaignArtChange = async (data) => {
  const response = await axiosWithToken.post(
    'campaign/art_change/action',
    data
  );

  const request = JSON.parse(response.data.body);

  return parseArtDesignsRequest(request);
};
